import { getPersistedQueryOptions } from '#pplx/frontend/react-query/internal/getPersistedQueryOptions.js';
import { useQueryClientProviderConfig } from '#pplx/frontend/react-query/QueryClientProviderContext.js';
import { useQueryClient, useQuery as useReactQuery } from '@tanstack/react-query';
export function useQuery(options, queryClient) {
    let reactQueryClient = useQueryClient();
    if (queryClient)
        reactQueryClient = queryClient;
    const { allowPersist } = useQueryClientProviderConfig();
    return useReactQuery(getPersistedQueryOptions({ options, queryClient: reactQueryClient, allowPersist }), queryClient);
}
//# sourceMappingURL=useQuery.js.map